module.exports = __webpack_public_path__ + "static/img/xxfw2.2c6386e9.png";